import Requester from '../core/request'
import { generateCacheKey } from '../core/helpers'
import { Ccp } from './ccp'
import { User } from './user'
import { Widget } from './widget'

export default class Api {
  constructor(config) {

    const requestHeaders = {
      ...(config.identifier ? { 'x-identifier': config.identifier } : {}),
      ...(config.token ? { 'x-auth-token': config.token } : {}),
      ...('safeMode' in config ? { 'x-safemode': typeof config.safeMode === 'string' ? (config.safeMode === '1' || config.safeMode === 'true') : config.safeMode } : {}),
    }

    this.generateCacheKey = generateCacheKey(config.api)

    this.requester = new Requester({
      apiUrl: config.api,
      token: config.token,
      identifier: config.identifier ? config.identifier : '',
      requestHeaders,
      cacheIdentifier: config.cacheIdentifier,
      generateCacheKey: this.generateCacheKey,
    })

    this.ccp = new Ccp(this)
    this.user = new User(this)
    this.widget = new Widget(this)
  }

  set token(value) {
    this.requester.token = value
  }
  set hooks(value) {
    this.requester.hooks = value
  }
  set handlers(value) {
    this.requester.handlers = value
  }
  set safeMode(value) {
    this.requester.safeMode = value
  }
}
